import { combineReducers } from 'redux';
import { CORPORATE_BENEFICIAL_OWNER_ACTORS_SUBMITTED, CORPORATE_BENEFICIAL_SAVE_ERROR, SUBMITTING_CORPORATE_BENEFICIAL_OWNER_ACTORS } from '../actions/corporateBeneficialOwnerActors';
export const submitCorporateBeneficialOwnerActors = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    submitted: false
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CORPORATE_BENEFICIAL_OWNER_ACTORS_SUBMITTED:
      return {
        submitted: true
      };
    case SUBMITTING_CORPORATE_BENEFICIAL_OWNER_ACTORS:
      return {
        submitted: false
      };
    case CORPORATE_BENEFICIAL_SAVE_ERROR:
      return {
        submitted: false,
        error: action.error
      };
    default:
      return state;
  }
};
export default combineReducers({
  submitCorporateBeneficialOwnerActors
});